/* eslint-disable */
export const MY_API_URL = 'https://api.getwebsite.in/';
// export const MY_API_URL = 'https://api.ivoltech.com/';
// export const MY_API_URL = 'http://localhost:4200/';
export const TINYMCEAPIKEY = 'bjryztimfu41x1c36gaz2zslqmeocbmennkuvu310z5vmmc0';
export const AXIOSHEADERS = {
	'Content-Type': 'application/json',
};
export const LOGO_URL = 'https://crm.getwebsite.in/img/texpertlogo.png';

// "homepage": "https://texpert.tech",
// "homepage": "https://texpertstaging.ivoltech.com",
